import { createUseStyles } from 'react-jss';
import { ThemeType } from './jssTypes';

const useGlobalStyles = createUseStyles((theme: ThemeType) => ({
  '@global': {
    a: {
      color: theme.color.semantic.brand.default.primary,
      '&:hover, &:active': {
        color: theme.color.semantic.brand.default.secondary,
      },
      '&[disabled]': {
        color: theme.color.semantic.text.subtle,
      },
    },
    '.ant-checkbox-checked::after, .ant-radio-checked::after': {
      borderColor: theme.color.semantic.brand.default.primary,
    },
    '.ant-table-column-sorter-up.active, .ant-table-column-sorter-down.active, .ant-table-filter-trigger.active': {
      color: theme.color.semantic.brand.default.primary,
    },
    '.ant-pagination-item:hover, .ant-pagination-item:focus-visible, .ant-pagination-item-active': {
      borderColor: theme.color.semantic.brand.default.primary,
      '& a': {
        color: theme.color.semantic.brand.default.primary,
      },
    },
    '.ant-pagination-item-active:hover, .ant-pagination-item-active:focus-visible': {
      borderColor: theme.color.semantic.brand.default.secondary,
      '& a': {
        color: theme.color.semantic.brand.default.secondary,
      },
    },
    '.ant-pagination-prev:not(.ant-pagination-disabled):hover .ant-pagination-item-link, .ant-pagination-prev:not(.ant-pagination-disabled):focus-visible .ant-pagination-item-link, .ant-pagination-next:not(.ant-pagination-disabled):hover .ant-pagination-item-link, .ant-pagination-next:not(.ant-pagination-disabled):focus-visible .ant-pagination-item-link': {
      borderColor: theme.color.semantic.brand.default.primary,
      color: theme.color.semantic.brand.default.primary,
    },
    '.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon, .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon': {
      color: theme.color.semantic.brand.default.primary,
    },
  },
}));

const GlobalThemeStyles = () => {
  useGlobalStyles();
  return null;
};

export default GlobalThemeStyles;
